import React from 'react'
import Select from 'react-select-virtualized'

export default function SearchBar(props) {
  const { searchValue, setSearchValue, options, type } = props

  const customStyles = {
    menu: (provided, state) => ({
      ...provided,
      whiteSpace: 'nowrap',
      overflow: 'hidden'
    })
  }

  return (
    <Select
      styles={customStyles}
      value={searchValue}
      onChange={(e) => { setSearchValue(e) }}
      options={options}
      menuPlacement="auto"
      placeholder="Search"
      noOptionsMessage={() => type === 'location' ? (
        <div>
          <div>Location not found.</div>
          <div>Click the Reload button and try again</div>
          <div>or verify the address</div>
          <div>is valid in Snow Management.</div>
        </div>
      ) : 'No Options'
      }
    />
  )
}
